module.exports = __webpack_public_path__ + "static/media/C7259425-E99A-4192-9CF2-2E3E6DDE9944.96050dfb.jpeg";